import React from 'react'

const SocialLink = ({url, icon}) => {

      if(url.length === 0) return 

      return (
            <a href={url} className="btn_social__link flex" target="_blank" rel="noreferrer">{icon}</a>
      )
}

export default SocialLink
